import './Badge.css';

export const Badge = ({ children }) => {
  return <span className="badge">{children}</span>;
};
